import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class CustomerService {
  updateCustomer(customerId, data) {
    return securedAxiosInstance.put(`/customers/${customerId}`, toSnakeCase(data));
  }
}

export default new CustomerService();
